export const convertUrlObjectToFile = async (objectUrl: string, objectName = 'image.jpg') => {
  // const headers = new Headers();
  // headers.append('Access-Control-Allow-Origin', '*');
  const response = await fetch(objectUrl, {
    method: 'GET',
    // headers: headers,
    // mode: 'no-cors',
  });
  if (response.type === 'opaque') {
    throw new Error('opaque response returned');
  }
  const blob = await response.blob();
  return new File([blob], objectName, { type: blob.type });
};
